module.exports = __webpack_public_path__ + "img/service-234.37f07bfd.png";